<template>
    <b-row class="lsr-container">
      <!-- LEFT COLUMN -->
      <b-col cols="12">
        <!-- TABS -->
        <b-row>
          <b-col>
            <template v-if="metadata['Fulltext'] && metadata['Fulltext'].length  && isNumericRegExp.test(metadata['Fulltext'])">
            <tab
              class="mt-4"
              :url="data[1]"
              :gid="metadata['Fulltext']"
              :language="language"
              :selectedLanguage="selectedLanguage"
              objKey = 'Fulltext'
              :sheets = sheets
              @leftMenu="adjustMenuOptions"
            />
            </template>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
</template>

<script>
// @ is an alias to /src
import SectionFooter from '@/components/SectionFooter.vue'
import Reference from '@/components/Reference.vue'
import RightSidebar from '@/components/RightSidebar.vue'
import TableLove from '@/components/Table.vue'
import Tab from '@/components/Tab.vue'
import axios from 'axios'
import parse from 'csv-parse'
import jwt from 'jsonwebtoken'

export default {
  name: 'Results',
  data() {
    return {
      csvData : [],
      isNumericRegExp: new RegExp('^\\d+$'),
      data: [],
      metadata: {
        'Title': "",
        "Summary": "",
        "Fulltext": "",
        "Appendix": "",
        "Abstact": "",
        "Author": "",
        "Last published version": "",
        "Date of last update": ""
      },
      language: {
        "EN": 1,
        "ES": 2,
      },
      selectedLanguage: "EN",
      menuOptions: {},
      currentTabs: 0,
      count: 0,
      scrollId : '-1'
    }
  },
  components: {
    'reference': Reference,
    'section-footer': SectionFooter,
    'sidebar': RightSidebar,
    'table-lovely': TableLove,
    'tab': Tab
  },
  mounted: async function() {
    await this.$store.dispatch('createJWT', {})
    const config = {
        headers: { Authorization: `Bearer ${this.$store.state.token}` }
      }
    const url = 'https://api.iloveevidence.com/v2.1'
    const pretty_url = this.$route.params.lsrid
    if (this.$route.query.lang && this.language.hasOwnProperty(this.$route.query.lang.toUpperCase())){
      this.selectedLanguage = this.$route.query.lang.toUpperCase()
    }
    axios.get(
          url + '/LSR/' + pretty_url
        ).then((res1) => {
          if (res1.data.hasOwnProperty("status") && !res1.data.status) {
            this.metadata.title = 'PAGE NOT FOUND'
            return
          }
          this.data = [res1.data.title, res1.data.spread_id, res1.data.mainmetadata_gid, res1.data.pretty_url]
        axios.get(
          'https://sheets.googleapis.com/v4/spreadsheets/'+ this.data[1], config
        )
        .then((res2)=>{
          this.sheets = res2.data.sheets
          const gid = this.getSheetNumberByGid(res2.data.sheets, res1.data.mainmetadata_gid)
          const title = res2.data.sheets[gid].properties.title
          axios.get(
        'https://sheets.googleapis.com/v4/spreadsheets/'+ this.data[1] + '/values/'+ title+'!A1:AZ9999', config
        ).then( (res) => {
          if (!res.data.hasOwnProperty('values')) {
           return
         }
          for (let i = 0 ; i < res.data.values.length; i++) {
            if (res.data.values[i] 
              && res.data.values[i] != "") {
              const lsrid = res.data.values[i] 
              this.processRow(this, lsrid)
            } else {
              break
            }
          }})})
  })},
  methods: {
    processRow: function(vm, record){
      if (record.length){
        if (record[0]==='Title'){
          vm.metadata[record[0]]=record
        }
        else {
          vm.metadata[record[0]]=record[1]
        }
      }
      },
    adjustMenuOptions: function(options, ids, key) {
      this.menuOptions[key]={content: options, id: ids}
      this.count+=1
    },
    async createJwt () {
      const secret =  "-----BEGIN PRIVATE KEY-----\nMIIEvAIBADANBgkqhkiG9w0BAQEFAASCBKYwggSiAgEAAoIBAQC0EbV8Gja2NCE+\nldXOBQ+eoGesFUS6c77rympu1duQK5tGZqpISNTEFc33irlv53OlcyK8pIa/cZ1v\nMD6r67dP6xziAY6a+A2gMDyqFT7E/ICUwZv91r8pGSxh+qKRWrWVaN0/yYlzLHXt\n7zfCguLWINkNGctfwpELcbMPt2UlXQs8fKf7LbQiwo3WZAtpkWnEzC6C554qhiDN\nvxQlcwV9VpLJipKbKr+YB+1SGlIvpuqBZI8ZwShLfjq95tP8Vow9dZ7qm+dshAek\nB6ogZruSw6FuFoxlOTutMbtlCwDGsYth5kjbYUXdcRRdgCGa2cN8KYR+Vy+8JEuX\no9BeMwG5AgMBAAECgf9JgPEUN58dwSnQ4ljkQCygE9o95HCpq5XDqlzH4YQ+1Y4M\nrtvTpec0I7Jv2bDYfSI350fGuWJHw5kASjFK/G1XsiGYIAqWN6tYOFiLFSEKSAg0\nsNN8Sqy9mgkD9ctmiiCVXLjz0NDKsttwxLV+MO9neQEg1+assD+E7GSrhbFEDoeS\n/Yv0EJGBQbrEkmMJhPow5BcXUHkjgzmgOdgRL6wm/1vQyrIiNMTolDpSOUTu2kwh\n1mw8KtdeLz7I+9euVLW6NuM2SfJCsSIWVqhy+9fLYlhqto4vIt2BHVPLsrQZEdv8\nXQRJgg8GqPLF2MTDVBq9gGUm8ZchLD7d5wtUmqkCgYEA4GCd9JwMtr1KhZ68CJiO\nXXD6TFrNsHplUuBA61YbdkeZR+qLQIXhYQ+tKM2f+n2OeqZOY5Iul6TZcXFjXb7Y\nDwlGbtqioH8OeZll0BYv11bUXdRlsXP54exyzeTx9iAS0FjonYcEUQqYvoInpe80\nyxqHnoufRjgnV8dYEOeB7B0CgYEAzXJ7MHJ0OnhFPNOz4XpGYY22P0qhu5U3L5Qy\nSmN6fnUETwDs62A+lV8UnZDYb88xmFBYLc0rfPdsKiOIDH82fQ+fmFt784PH4d/U\nsiOW8Qa1WiK78neD0qv46NIaRLhS5IuB8zqUdCCzpt0SkDl+GUjgCRfcEIg+LUky\nPkfIYU0CgYARWQb9YY9OFaaMXDB3jav8J38Cpkae7WemF7aNO3QWGgUM3WJ006UQ\nRxEBRZyn1ktMykznP+cgTFuPfM/M8LNtvi7W5UqLlCc/WY/Ync6HHKyAsKpIJQpd\n4FUj/B6FBAfQWf9qJoU76tDScee02aDAT0XLCUqAOFk6XSw+6ldONQKBgQCKFGpl\nWldxwMnQIv0gCz1obYVSroda+uPXT4QpaQi4G0+lBZs2az5EyF2jtOky5I+RrlZF\nmkKjP+vrumvC8nEdxrVeAgah2S0rS3O5sp/NKNQUW4n0YY0wt7KYUDWlgDj+MCFL\n51BFaIE2IhlK48kzlz4z/lxCpD8d0rc5EqfDdQKBgQCVmCr0HOwY7s1UGUdgOXUS\nGsnJZM/6DIZqFjzwHJQGbHgVWgE/RxisCki8WH+2+7SEFhlBdURSRYDRLtcffqv8\nButT99Hd8VfrkEyxwNgcq4ABSx2yZDUtNNzXJAYvjDdEZ1YqluUJ+quUecOj/0wd\nQSrbgZZF8zJx+Qz5tRasig==\n-----END PRIVATE KEY-----\n"
      const date = new Date()
      const seconds = Math.floor(date.getTime() / 1000)
      const expSeconds = seconds + 60 * 60
      const payload = {
        iss: "planilla-love@planilla-love.iam.gserviceaccount.com",
        scope: 'https://www.googleapis.com/auth/drive',
        aud: 'https://oauth2.googleapis.com/token',
        exp: expSeconds,
        iat: seconds
      }
      const token = jwt.sign(payload, secret, { algorithm: 'RS256' })
      const oAuthPayload = {
        grant_type: 'urn:ietf:params:oauth:grant-type:jwt-bearer',
        assertion: token
      }
      await axios.post('https://oauth2.googleapis.com/token', oAuthPayload)
        .then((res) => { localStorage.setItem('gapi.access_token', res.data.access_token) })
        .catch((err) => { console.log(err) })
      return token
    },
    scroll: function(index, content) {
      if (this.currentTabs == index) {
        this.$scrollTo("#"+content)
      }
      else {
        this.currentTabs = index
        setTimeout(() => {
          this.$scrollTo("#"+content)
        }, 360)
      }
    },
    getSheetNumberByGid: function(data, gid) {
      for (let i = 0; i < data.length; i++) {
        if (gid == data[i].properties.sheetId) {
          return i
        }
      }
    } 
    }
}
</script>

<style lang="scss" scoped>
  @import "../assets/styles/variables.scss";
  a {
    color: $dark-green;
  }
  .lsr-container {
    h1 {
      font-size: 1.7em;
    }
    h2 {
      font-size: 1.2em;
    }
    h3 {
      font-size: 1.1em;
    }

    .header {
      margin-bottom: 2em;
      h1 {
        font-weight: bold;
        margin-top: 0.3em;
        margin-bottom: 1em;
      }
      .publication-type {
        font-weight: bold;
        font-size: 0.9em;
      }
      .authors, .dates {

      }
    }

    .tab_content {
      .languages {
        margin-bottom: 2em;
      }
      h1:not(:first-child) {
        margin-top: 1.8em;
      }
      h2 {
        font-weight: bold;
        &:not(:first-child) {
          margin-top: 1.4em;
        }
      }
      h3 {
        font-style: italic;
        &:not(:first-child) {
          margin-top: 1.2em;
        }
      }
      ul.arrow {
        margin-inline-start: 1.5em;
        // li:before {
        //   font-family: 'FontAwesome';
        //   content: '\f061'
        // }
      }
    }

    .title {
      color: $dark-green
    }

    .language {
      cursor: pointer;
      background-color: #dee2e6;
      font-weight: bold;
      border-radius: 5px;
      text-align: center;
      margin: 0vw 2px;
    }
    .selected {
        background-color: $dark-green;
        color: white;
        border: 1px solid #dee2e6;
      }
  }
</style>
<style lang="scss">
  @import "../assets/styles/variables.scss";
  .nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link{
    background-color: $dark-green;
    color: white;
    border-radius: 8px 8px 0px 0px;
  }
  .nav-tabs .nav-link{
    color: black;
    border-radius: 8px 8px 0px 0px;
    border: 1px solid #dee2e6;
    margin: 0px 2px;
  }

  .nav-tabs .nav-link:hover{
    background-color: $dark-green;
    color: white;
    border-radius: 8px 8px 0px 0px;
  }
</style>